<template>
  <login-layout ref="login-layout" :region-data="regionData">
    <default-page-layout class="items-center">
      <div>
        <warning-box
          id="login-page_error-notification"
          v-if="hasError"
          class="mt-6 min-w-140"
          type="error"
          is-content-centered
        >
          <div class="flex flex-col">
            <span v-for="(message, id) in errorMessages" :key="id">
              {{ message }}
            </span>
            <span
              v-if="showRegionHint"
              class="text-link cursor-pointer"
              @click="onCheckRegionClick"
            >
              {{ $t("App.Regions.checkYourRegion") }}
            </span>
          </div>
        </warning-box>
        <warning-box
          v-if="lockoutWarningMessage"
          class="mt-6 min-w-140"
          type="warning"
        >
          {{ lockoutWarningMessage }}
        </warning-box>
      </div>
      <tabs class="mt-6 min-w-140">
        <tab :name="$t('LoginPage.loginButton')" :selected="true">
          <login-form @logged="onLogin" @loginError="onLoginError" />
          <router-link
            class="block mt-5 text-center"
            :to="{ name: 'forgotPassword' }"
          >
            {{ $t("LoginPage.forgotPassword") }}
          </router-link>
          <router-link
            class="block mt-5 text-center"
            :to="{ name: 'requestSAMLSite' }"
          >
            {{ $t("LoginPage.forgotSAMLLoginPage") }}
          </router-link>
        </tab>
      </tabs>
    </default-page-layout>
  </login-layout>
</template>

<script>
import LoginLayout from "@/components/layout/LoginLayout.vue";
import DefaultPageLayout from "@/components/layout/DefaultPageLayout.vue";
import WarningBox from "@/components/ui/WarningBox.vue";
import LoginForm from "@/components/login/LoginForm.vue";
import Tabs from "@/components/ui/Tabs.vue";
import Tab from "@/components/ui/Tab.vue";
import loadConfigData from "@/services/configJson";

export default {
  components: {
    DefaultPageLayout,
    WarningBox,
    Tabs,
    Tab,
    LoginForm,
    LoginLayout,
  },
  data() {
    return {
      hasError: false,
      errorMessages: [],
      lockoutWarningMessage: "",
      regionData: [],
      isAccountDeactivated: false,
    };
  },
  mounted() {
    this.loadRegionData();
  },
  computed: {
    showRegionHint() {
      return this.regionData?.length > 1 && !this.isAccountDeactivated;
    },
  },
  methods: {
    async loadRegionData() {
      this.regionData = (await loadConfigData()).Regions;
    },
    onLogin() {
      // Attempt restoring the previously seen page after login
      if (this.$route.query?.previousPath) {
        // Remove the previous path from the query but keep the rest
        const query = Object.assign({}, this.$route.query);
        delete query.previousPath;
        // It can fail and will fall back to home in that case in the routing code
        this.$router
          .push({ path: this.$route.query.previousPath, query: query })
          .catch(() => {});
      } else {
        this.$router.push({ name: "home" }).catch(() => {});
      }
      this.hasError = false;
    },
    onLoginError(errorMessage, warningMessage, isAccountDeactivated) {
      this.errorMessages = errorMessage ? errorMessage.split("\n") : [];
      this.lockoutWarningMessage = warningMessage;
      this.hasError = true;
      this.isAccountDeactivated = isAccountDeactivated;
    },
    onCheckRegionClick() {
      const loginLayout = this.$refs["login-layout"];
      if (loginLayout) {
        loginLayout.openRegionSelectionModal();
      }
    },
  },
};
</script>
